import React, { PureComponent } from 'react';
import { ServicesProvider } from '@wix/experts-common';
import ServiceCategory from './ServiceCategory';
import s from './zeroState.scss';

class ZeroState extends PureComponent {
  componentDidMount() {
    const {
      services: { withBI },
    } = this.context;
    withBI({ evid: 141, typeid: 1 });
  }

  render() {
    const {
      categories,
      onServiceClick,
      onCategoryClick,
      staticsBaseUrl,
    } = this.props;
    return (
      <div className={s.root} data-hook="explore-zero-state">
        <div className={s.serviceCategories}>
          {Object.keys(categories).map(categoryId => (
            <ServiceCategory
              key={categoryId}
              categoryId={categoryId}
              services={categories[categoryId]}
              onServiceClick={onServiceClick}
              onCategoryClick={onCategoryClick}
              staticsBaseUrl={staticsBaseUrl}
            />
          ))}
        </div>
      </div>
    );
  }
}

ZeroState.contextTypes = ServicesProvider.childContextTypes;

export default ZeroState;
